<template>
    <v-card xs12>

        <v-toolbar>
            <DatesPicker v-model="selectedDateRange"></DatesPicker>
            <v-divider vertical style="margin-left: 8px; margin-right: 8px"></v-divider>
            <ClassPickerAutocomplete
                    :useQueryString="true"
                    v-model="selectedClassId"
            ></ClassPickerAutocomplete>
        </v-toolbar>

        <v-card-text>
            <ClassHistoryChart
                    :classId="selectedClassId"
                    :startDate="selectedDateRange ? selectedDateRange.startDate : undefined"
                    :endDate="selectedDateRange ? selectedDateRange.endDate : undefined"
            ></ClassHistoryChart>
        </v-card-text>
    </v-card>
</template>

<script>
    import ClassHistoryChart from "./ClassHistoryChart";
    import DatesPicker from "@/components/DatesPicker.vue"
    import ClassPickerAutocomplete from '@/components/ClassPickerAutocomplete.vue'

    export default {
        name: "ClassHistory",
        components: {DatesPicker, ClassHistoryChart, ClassPickerAutocomplete},
        data: function () {
            let routeClassId = this.$router.currentRoute.query['classId'] ? +this.$router.currentRoute.query['classId'] : undefined;
            return {
                selectedDateRange: {
                    startDate: undefined,
                    endDate: undefined,
                },

                classId: routeClassId,
                selectedClassId: routeClassId,
            }
        },

        methods: {
        },
        mounted() {
            // set toolbar title
            this.$store.commit('setToolbarOptions', {
                title: 'Class History',
                subTitle: '',
                hideSearch: false,
                backButtonRoute: {name: 'reports', query: isNaN(this.selectedClassId) ?
                        {} :
                        {classId: this.selectedClassId}
                }
            });
        }
    }
</script>

<style scoped>

</style>
